import React, { useState, useEffect, useRef } from 'react';
import '../styles/Projects.css';
import songSageThumbnail from '../images/projects/songsage/thumbnail.png';
import Carousel from './Carousel';
import CodeDisplay from './CodeDisplay';
import StlModelViewer from './StlViewer';
import ImagePopupWrapper from './ImagePopupWrapper';
import FlangerDemo from './FlangerDemo';

// Import all screenshots
import screenshot1 from '../images/projects/songsage/screenshot1.png';
import screenshot2 from '../images/projects/songsage/screenshot2.png';
import screenshot3 from '../images/projects/songsage/screenshot3.png';
import screenshot4 from '../images/projects/songsage/screenshot4.png';
import screenshot5 from '../images/projects/songsage/screenshot5.png';
import screenshot6 from '../images/projects/songsage/screenshot6.png';
import screenshot7 from '../images/projects/songsage/screenshot7.png';

// Import backend diagrams
import backend1 from '../images/projects/songsage/backend1.png';
import backend2 from '../images/projects/songsage/backend2.png';

// Add import for v0idportal thumbnail
import v0idportalThumbnail from '../images/projects/v0idportal/thumbnail.png';

// Add import for v0id build image
import v0idBuildImage from '../images/projects/v0idportal/v0id-build.png';

// Import scene images
import scene1 from '../images/projects/v0idportal/scene1.png';
import scene2 from '../images/projects/v0idportal/scene2.png';
import scene3 from '../images/projects/v0idportal/scene3.png';
import scene4 from '../images/projects/v0idportal/scene4.png';
import scene5 from '../images/projects/v0idportal/scene5.png';
import scene6 from '../images/projects/v0idportal/scene6.png';
import scene7 from '../images/projects/v0idportal/scene7.png';
import scene8 from '../images/projects/v0idportal/scene8.png';
import scene9 from '../images/projects/v0idportal/scene9.png';
import scene10 from '../images/projects/v0idportal/scene10.png';
import scene11 from '../images/projects/v0idportal/scene11.png';
import scene12 from '../images/projects/v0idportal/scene12.png';

// Add import for sarcastic-box thumbnail
import sarcasticBoxThumbnail from '../images/projects/sarcastic-box/thumbnail.png';

// Add imports for sarcastic-box images
import sarcasticBoxBreadboard from '../images/projects/sarcastic-box/breadboard-diagram.png';
import sarcasticBoxSchematic from '../images/projects/sarcastic-box/schematic.png';
import sarcasticBoxPrototype from '../images/projects/sarcastic-box/prototype.png';
import sarcasticBoxPortrait from '../images/projects/sarcastic-box/cardboard-box-portrait.png';

// Add the code string constant (place this with other constants)
const V0ID_PORTAL_CODE = `import cv2
import numpy as np
from gpiozero import Button
import random
import pygame

button = Button(2)
last_vid = -1
window_num = 0

# Initialize pygame mixer for audio playback
pygame.mixer.init()
portal_soundscape = "portal_soundscape.mp3"

# Portals
vids = ['vid1.mp4', 'vid2.mp4', 'vid3.mp4', 'vid4.mp4', 'vid5.mp4', 'vid6.mp4', 'vid7.mp4', 'vid8.mp4', 'vid9.mp4', 'vid10.mp4',
        'vid11.mp4', 'vid12.mp4', 'vid13.mp4', 'vid14.mp4', 'vid15.mp4', 'vid16.mp4', 'vid17.mp4', 'vid18.mp4', 'vid19.mp4', 'vid20.mp4']

# Predefined random timestamps for each video
soundscape_timestamps = {
    'vid1.mp4': 17, 'vid2.mp4': 34, 'vid3.mp4': 22, 'vid4.mp4': 28, 'vid5.mp4': 19,
    'vid6.mp4': 36, 'vid7.mp4': 21, 'vid8.mp4': 32, 'vid9.mp4': 25, 'vid10.mp4': 30,
    'vid11.mp4': 18, 'vid12.mp4': 35, 'vid13.mp4': 20, 'vid14.mp4': 27, 'vid15.mp4': 23,
    'vid16.mp4': 38, 'vid17.mp4': 29, 'vid18.mp4': 26, 'vid19.mp4': 31, 'vid20.mp4': 24
}

def run_it():
    global last_vid, window_num, vids
    rand_vid = last_vid

    while rand_vid == last_vid:
        rand_vid = random.randint(0, 19)

    last_vid = rand_vid

    file_name = vids[rand_vid]
    window_name = "window" + str(window_num)
    interframe_wait_ms = 5

    cap = cv2.VideoCapture(file_name)
    if not cap.isOpened():
        print("Error: Could not open video.")
        exit()

    cv2.namedWindow(window_name, cv2.WND_PROP_FULLSCREEN)
    cv2.setWindowProperty(window_name, cv2.WND_PROP_FULLSCREEN, cv2.WINDOW_FULLSCREEN)
    
    frame_count = int(cap.get(cv2.CAP_PROP_FRAME_COUNT))
    fps = int(cap.get(cv2.CAP_PROP_FPS))
    
    # Use the predefined timestamp for this video
    soundscape_start_time = soundscape_timestamps[file_name]
    soundscape_start_frame = soundscape_start_time * fps

    last_frame = None
    frame_index = 0
    soundscape_played = False

    while True:
        ret, frame = cap.read()
        if not ret:
            break

        last_frame = frame  # Store the last valid frame
        cv2.imshow(window_name, frame)

        if frame_index >= soundscape_start_frame and not soundscape_played:
            pygame.mixer.music.load(portal_soundscape)
            pygame.mixer.music.play(-1)  # Loop infinitely
            soundscape_played = True

        if cv2.waitKey(interframe_wait_ms) & 0x7F == ord('q'):
            break

        if button.is_pressed:
            cap.release()
            pygame.mixer.music.stop()
            return  # Exit current function and wait for next button press
        
        frame_index += 1
    
    cap.release()
    
    # Loop the last frame continuously until the button is pressed
    while True:
        cv2.imshow(window_name, last_frame)
        if cv2.waitKey(interframe_wait_ms) & 0x7F == ord('q'):
            break
        if button.is_pressed:
            pygame.mixer.music.stop()
            break
    
    if window_num > 0:
        delete_num = window_num - 1
        cv2.destroyWindow("window" + str(delete_num))
    
    window_num += 1
    run_it()

button.wait_for_press()
run_it()`;

const SARCASTIC_BOX_CODE = `#include "SoftwareSerial.h"
#include "DFRobotDFPlayerMini.h"

// Use pins 2 and 3 to communicate with DFPlayer Mini
static const uint8_t PIN_MP3_TX = 2; // Connects to module's RX 
static const uint8_t PIN_MP3_RX = 3; // Connects to module's TX 
const int micPin = A0;
int micValue = 0; 

SoftwareSerial softwareSerial(PIN_MP3_RX, PIN_MP3_TX);

// Create the Player object
DFRobotDFPlayerMini player;

int lastNum = 0;
int random_number = 7;

void setup() {
  // Init USB serial port for debugging
  Serial.begin(9600);
  // Init serial port for DFPlayer Mini
  softwareSerial.begin(9600);
  
  while(!player.begin(softwareSerial)) {
    Serial.println("Connecting to DFPlayer Mini failed!");
  }

  if (player.begin(softwareSerial)){
    Serial.println("OK");
  }
}

void loop() {
  micValue = analogRead(micPin);
  Serial.println(micValue);
  delay(100);

  if(micValue >= 580){
    player.volume(20);
    Serial.println("Too loud!");
    
    player.play(1);
    Serial.println("Playing Siren");
    delay(5000);
    
    player.volume(30);
    if(random_number == 2){
      player.play(3);
      delay(16000);
    }
    else if(random_number == 3){
      player.play(5);
      delay(18000);
    }
    else if(random_number == 4){
      player.play(7);
      delay(20000);
    }
    else if(random_number == 5){
      player.play(9);
      delay(16000);
    }
    else if(random_number == 6){
      player.play(11);
      delay(14000);
    }
    else if(random_number == 7){
      player.play(13);
      delay(17000);
    }

    random_number++;
    if(random_number > 7){
      random_number = 2;
    }

    micValue = 0;
  }
}`;

const FLANGEBENDER_CODE = `/*  Teensy 4.1 dual-ToF flange controller
    – Sensor #1 controls rate (s_freq)
    – Sensor #2 controls depth (s_depth)
*/

#include <Audio.h>
#include <Wire.h>
#include <SPI.h>
#include <SD.h>
#include <SerialFlash.h>
#include <Adafruit_VL53L0X.h>

// ───────────────────────────────── AUDIO GRAPH ──
AudioPlaySdWav           playWav1;
AudioInputI2S            audioInput;
AudioEffectFlange        l_flange, r_flange;
AudioMixer4              mixer1, mixer2;
AudioOutputI2S           audioOutput;
AudioConnection          patchCord1(playWav1, 0, mixer1, 0);
AudioConnection          patchCord2(audioInput, 0, mixer1, 1);
AudioConnection          patchCord3(playWav1, 1, mixer2, 0);
AudioConnection          patchCord4(audioInput, 1, mixer2, 1);
AudioConnection          patchCord5(mixer1   , 0, l_flange, 0);
AudioConnection          patchCord6(mixer2   , 0, r_flange, 0);
AudioConnection          patchCord7(l_flange , 0, audioOutput, 0);
AudioConnection          patchCord8(r_flange , 0, audioOutput, 1);
AudioControlSGTL5000     audioShield;

// ─────────────────────────────── FLANGE SETTINGS ──
#define FLANGE_DELAY_LENGTH (6*AUDIO_BLOCK_SAMPLES)
short l_delayline[FLANGE_DELAY_LENGTH];
short r_delayline[FLANGE_DELAY_LENGTH];
int    s_idx   = FLANGE_DELAY_LENGTH / 4;
int    s_depth = FLANGE_DELAY_LENGTH / 4;  // live-controlled
double s_freq  = 0.10;                     // live-controlled
bool   flangeActive = true;

// ──────────────────────────────── ToF SENSORS ──
Adafruit_VL53L0X lox1, lox2;
const int XSHUT_pin1 = 2;
const int XSHUT_pin2 = 3;

// user-tunable sensor-to-flange mapping
const uint16_t MIN_MM   =  40, MAX_MM   = 600;
const double   MIN_FREQ = 0.05, MAX_FREQ = 0.80;
const int      MAX_DEPTH = FLANGE_DELAY_LENGTH / 2;

// ──────────────────────────────────────────── SETUP
void setup() {
  Serial.begin(9600);
  Wire.begin();

  pinMode(XSHUT_pin1, OUTPUT);
  pinMode(XSHUT_pin2, OUTPUT);
  digitalWrite(XSHUT_pin1, LOW);
  digitalWrite(XSHUT_pin2, LOW);
  delay(10);

  digitalWrite(XSHUT_pin1, HIGH);
  delay(10);
  lox1.begin(0x30);          // sensor 1 → 0x30

  digitalWrite(XSHUT_pin2, HIGH);
  delay(10);
  lox2.begin(0x31);          // sensor 2 → 0x31

  AudioMemory(12);
  audioShield.enable();
  audioShield.inputSelect(AUDIO_INPUT_LINEIN);
  audioShield.volume(0.5f);

  mixer1.gain(0, 0.5);  mixer1.gain(1, 0.5);
  mixer2.gain(0, 0.5);  mixer2.gain(1, 0.5);

  l_flange.begin(l_delayline, FLANGE_DELAY_LENGTH, s_idx, s_depth, s_freq);
  r_flange.begin(r_delayline, FLANGE_DELAY_LENGTH, s_idx, s_depth, s_freq);

  // Auto-start the sample once
  playWav1.play("01.wav");
  delay(5);
}

// ───────────────────────────────────────────── LOOP
double mapDouble(double x, double in_min, double in_max,
                 double out_min, double out_max) {
  return (x - in_min) * (out_max - out_min)
       / (in_max - in_min) + out_min;
}

void loop() {
  VL53L0X_RangingMeasurementData_t m1, m2;
  lox1.rangingTest(&m1, false);
  lox2.rangingTest(&m2, false);

  if (m1.RangeStatus != 4 && m2.RangeStatus != 4) {
    // rate ↔ sensor 1
    double newFreq = mapDouble(m1.RangeMilliMeter,
                               MIN_MM, MAX_MM,
                               MAX_FREQ, MIN_FREQ);
    newFreq = constrain(newFreq, MIN_FREQ, MAX_FREQ);

    // depth ↔ sensor 2
    int newDepth = map(m2.RangeMilliMeter,
                       MIN_MM, MAX_MM,
                       MAX_DEPTH, 0);
    newDepth = constrain(newDepth, 0, MAX_DEPTH);

    if (fabs(newFreq - s_freq) > 0.01 || newDepth != s_depth) {
      s_freq  = newFreq;
      s_depth = newDepth;
      l_flange.voices(s_idx, s_depth, s_freq);
      r_flange.voices(s_idx, s_depth, s_freq);
    }
  }

  // auto-restart the WAV if it stops
  if (!playWav1.isPlaying()) {
    playWav1.play("01.wav");
    delay(5);
  }
}`;

// Add import for flangebender thumbnail
import flangebenderThumbnail from '../images/projects/flangebender-p/thumbnail.png';

// Add import for stock-sentiment-tracker thumbnail
import stockSentimentTrackerThumbnail from '../images/projects/sentiment-tracker/thumbnail.png';

// Add import for remote-viewing-session-guide thumbnail
import remoteViewingSessionGuideThumbnail from '../images/projects/remote-viewing/thumbnail.png';

// Add import for the-bold-unknown-content-generator thumbnail
import theBoldUnknownContentGeneratorThumbnail from '../images/projects/the-bold-unknown-content-generator/thumbnail.png';

// Add imports for VerseForThis
import verseForThisThumbnail from '../images/projects/verse-for-this/thumbnail.png';
import verseForThisDailyScripture from '../images/projects/verse-for-this/01-verse-of-the-day.png';
import verseForThisGuidedExperience from '../images/projects/verse-for-this/02-query-results.png';
import verseForThisBibleContext from '../images/projects/verse-for-this/03-bible.png';
import verseForThisPrayer from '../images/projects/verse-for-this/04-prayer.png';
import verseForThisShareableCards from '../images/projects/verse-for-this/05-share.png';
import appleLogo from '../images/projects/verse-for-this/apple-logo-black.png';

// Add imports for stock-sentiment-tracker carousel images
import sentimentG1 from '../images/projects/sentiment-tracker/g1.png';
import sentimentG2 from '../images/projects/sentiment-tracker/g2.png';
import sentimentG3 from '../images/projects/sentiment-tracker/g3.png';
import sentimentG4 from '../images/projects/sentiment-tracker/g4.png';
import sentimentG5 from '../images/projects/sentiment-tracker/g5.png';
import sentimentG6 from '../images/projects/sentiment-tracker/g6.png';
import sentimentG7 from '../images/projects/sentiment-tracker/g7.png';
import sentimentG8 from '../images/projects/sentiment-tracker/g8.png';
import sentimentC1 from '../images/projects/sentiment-tracker/c1.png';
import sentimentC2 from '../images/projects/sentiment-tracker/c2.png';
import sentimentC3 from '../images/projects/sentiment-tracker/c3.png';
import sentimentC4 from '../images/projects/sentiment-tracker/c4.png';
import sentimentC5 from '../images/projects/sentiment-tracker/c5.png';

// Add imports for flangebender images
import flangebenderBreadboard from '../images/projects/flangebender-p/flanger-breadboard.png';
import flangebenderSchematic from '../images/projects/flangebender-p/flanger-schematic.png';
import flangebenderElectronics from '../images/projects/flangebender-p/flanger-electronics.png';

// Add imports for the-bold-unknown-content-generator thumbnails
import theBoldUnknown1 from '../images/projects/the-bold-unknown-content-generator/1.png';
import theBoldUnknown2 from '../images/projects/the-bold-unknown-content-generator/2.png';
import theBoldUnknown3 from '../images/projects/the-bold-unknown-content-generator/3.png';
import theBoldUnknown4 from '../images/projects/the-bold-unknown-content-generator/4.png';
import theBoldUnknown5 from '../images/projects/the-bold-unknown-content-generator/5.png';
import theBoldUnknown6 from '../images/projects/the-bold-unknown-content-generator/6.png';
import theBoldUnknown7 from '../images/projects/the-bold-unknown-content-generator/7.png';
import theBoldUnknown8 from '../images/projects/the-bold-unknown-content-generator/8.png';
import theBoldUnknown9 from '../images/projects/the-bold-unknown-content-generator/9.png';
import theBoldUnknown10 from '../images/projects/the-bold-unknown-content-generator/10.png';
import theBoldUnknown11 from '../images/projects/the-bold-unknown-content-generator/11.png';

const PROJECT_ORDER = [
  'stock-sentiment-tracker',
  'verse-for-this',
  'songsage',
  'the-bold-unknown-content-generator',
  'flangebender-p',
  'v0idportal'
];

const Projects = ({ category }) => {
  const [projects, setProjects] = useState([]);
  const [expandedId, setExpandedId] = useState(null);
  const projectRefs = useRef({});
  const audioElementsRef = useRef(new Map()); // Persist audio elements across re-renders

  // Debug function to monitor audio state
  const debugAudioState = () => {
    const audioElements = audioElementsRef.current;
    console.log('Current audio elements:', audioElements.size);
    audioElements.forEach((audio, path) => {
      console.log(`${path}: paused=${audio.paused}, currentTime=${audio.currentTime}, volume=${audio.volume}`);
    });
  };

  // Add debug function to window for testing (remove in production)
  useEffect(() => {
    window.debugAudioState = debugAudioState;
    return () => {
      delete window.debugAudioState;
    };
  }, []);

  // First useEffect to load and sort projects
  useEffect(() => {
    fetch('/data/projects.json')
      .then(response => response.json())
      .then(data => {
        const uniqueProjects = Object.values(
          data.projects.reduce((acc, project) => {
            if (!acc[project.id] || 
                (project.lastUpdated && (!acc[project.id].lastUpdated || 
                 new Date(project.lastUpdated) > new Date(acc[project.id].lastUpdated)))) {
              acc[project.id] = project;
            }
            return acc;
          }, {})
        );

        const filteredProjects = uniqueProjects.filter(project => {
          const hideAfter = project?.attributes?.hideAfter;
          const isExpired =
            !!hideAfter &&
            !Number.isNaN(Date.parse(hideAfter)) &&
            new Date() > new Date(hideAfter);

          const isHidden = project.hidden || isExpired;
          if (isHidden) return false;
          return category ? project.category === category : true;
        });

        const sortedProjects = [...filteredProjects].sort((a, b) => {
          const aIndex = PROJECT_ORDER.indexOf(a.id);
          const bIndex = PROJECT_ORDER.indexOf(b.id);
          const normalizedAIndex = aIndex === -1 ? PROJECT_ORDER.length : aIndex;
          const normalizedBIndex = bIndex === -1 ? PROJECT_ORDER.length : bIndex;

          return normalizedAIndex - normalizedBIndex;
        });
        setProjects(sortedProjects);
      })
      .catch(error => console.error('Error loading projects:', error));
  }, [category]);

  // Second useEffect to set up audio players after content is loaded and expanded
  useEffect(() => {
    if (projects.length > 0 && expandedId) {
      console.log('Setting up audio players');
      const buttons = document.querySelectorAll('.play-button');
      const audioElements = audioElementsRef.current; // Use persistent Map

      // Remove any existing event listeners first
      buttons.forEach(button => {
        const existingHandler = button._audioHandler;
        if (existingHandler) {
          button.removeEventListener('click', existingHandler);
        }
      });

      buttons.forEach(button => {
        const audioHandler = () => {
          const audioPath = button.dataset.audio;
          console.log('Attempting to play audio from path:', audioPath);
          
          // Prevent multiple rapid clicks
          if (button.classList.contains('loading')) {
            return;
          }
          
          if (!audioElements.has(audioPath)) {
            console.log('Creating new Audio element for:', audioPath);
            button.classList.add('loading');
            
            const audio = new Audio(audioPath);
            
            // Set volume to prevent clipping (adjust as needed)
            audio.volume = 0.7;
            
            audio.addEventListener('error', (e) => {
              console.error('Audio error:', e);
              console.error('Error details:', audio.error);
              button.classList.remove('loading');
              // Show error state briefly
              button.style.background = '#ff4444';
              setTimeout(() => {
                button.style.background = '';
              }, 1000);
            });

            audio.addEventListener('loadstart', () => {
              console.log('Audio loading started for:', audioPath);
            });

            audio.addEventListener('canplay', () => {
              console.log('Audio can play for:', audioPath);
              button.classList.remove('loading');
            });

            audio.addEventListener('loadeddata', () => {
              button.classList.remove('loading');
            });
            
            audioElements.set(audioPath, audio);
            
            audio.addEventListener('ended', () => {
              console.log('Audio ended for:', audioPath);
              button.classList.remove('playing');
            });
          }
          
          const audio = audioElements.get(audioPath);
          
          if (audio.paused) {
            console.log('Starting playback for:', audioPath);
            
            // Stop all other audio first
            audioElements.forEach(a => {
              if (a !== audio && !a.paused) {
                a.pause();
                a.currentTime = 0;
              }
            });
            buttons.forEach(b => {
              b.classList.remove('playing');
              b.classList.remove('loading');
            });
            
            // Check if audio is ready to play
            if (audio.readyState >= 2) { // HAVE_CURRENT_DATA or higher
              audio.play().catch(error => {
                console.error('Playback failed:', error);
                button.classList.remove('loading');
              });
              button.classList.add('playing');
            } else {
              // Audio not ready, show loading and wait
              button.classList.add('loading');
              const playWhenReady = () => {
                audio.removeEventListener('canplay', playWhenReady);
                button.classList.remove('loading');
                audio.play().catch(error => {
                  console.error('Playback failed:', error);
                });
                button.classList.add('playing');
              };
              audio.addEventListener('canplay', playWhenReady);
            }
          } else {
            console.log('Stopping playback for:', audioPath);
            audio.pause();
            audio.currentTime = 0;
            button.classList.remove('playing');
          }
        };

        // Store the handler reference on the button for cleanup
        button._audioHandler = audioHandler;
        button.addEventListener('click', audioHandler);
      });

      return () => {
        console.log('Cleaning up event listeners');
        
        // Remove event listeners
        buttons.forEach(button => {
          const existingHandler = button._audioHandler;
          if (existingHandler) {
            button.removeEventListener('click', existingHandler);
            delete button._audioHandler;
          }
        });
        
        // Note: We don't clear audioElements here since we want to persist them
        // They will be cleaned up when the component unmounts
      };
    }
  }, [projects, expandedId]); // Run when projects or expandedId changes

  // Cleanup audio elements when component unmounts
  useEffect(() => {
    return () => {
      console.log('Component unmounting - cleaning up all audio elements');
      const audioElements = audioElementsRef.current;
      audioElements.forEach(audio => {
        audio.pause();
        audio.currentTime = 0;
        audio.src = ''; // Release the audio resource
      });
      audioElements.clear();
    };
  }, []);

  const toggleProject = (id) => {
    setExpandedId(expandedId === id ? null : id);
    
    // If we're expanding a project, scroll to it
    if (expandedId !== id && projectRefs.current[id]) {
      setTimeout(() => {
        const element = projectRefs.current[id];
        const thumbnail = element.querySelector('.project-thumbnail');
        const thumbnailRect = thumbnail.getBoundingClientRect();
        const offset = thumbnailRect.bottom + 2; // Add 2px to ensure the thumbnail is completely out of view
        
        window.scrollTo({
          top: window.scrollY + offset,
          behavior: 'smooth'
        });
      }, 100);
    }
  };

  const thumbnails = {
    'songsage': songSageThumbnail,
    'v0idportal': v0idportalThumbnail,
    'sarcastic-box': sarcasticBoxThumbnail,
    'flangebender-p': flangebenderThumbnail
  ,
    'stock-sentiment-tracker': stockSentimentTrackerThumbnail,
    'remote-viewing-session-guide': remoteViewingSessionGuideThumbnail,
    'the-bold-unknown-content-generator': theBoldUnknownContentGeneratorThumbnail,
    'verse-for-this': verseForThisThumbnail
  };

  const projectImages = {
    'songsage': [
      screenshot1,
      screenshot2,
      screenshot3,
      screenshot4,
      screenshot5,
      screenshot6,
      screenshot7
    ],
    'v0idportal': [
      scene1,
      scene2,
      scene3,
      scene4,
      scene5,
      scene6,
      scene7,
      scene8,
      scene9,
      scene10,
      scene11,
      scene12
    ],
    'sarcastic-box': {
      breadboard: sarcasticBoxBreadboard,
      schematic: sarcasticBoxSchematic,
      prototype: sarcasticBoxPrototype,
      portrait: sarcasticBoxPortrait
    },
    'flangebender-p': {
      breadboard: flangebenderBreadboard,
      schematic: flangebenderSchematic,
      electronics: flangebenderElectronics
    },
    'stock-sentiment-tracker': {
      webapp: [
        sentimentG1,
        sentimentG2,
        sentimentG3,
        sentimentG4,
        sentimentG5,
        sentimentG6,
        sentimentG7,
        sentimentG8
      ],
      cli: [
        sentimentC1,
        sentimentC2,
        sentimentC3,
        sentimentC4,
        sentimentC5
      ]
    },
    'the-bold-unknown-content-generator': [
      theBoldUnknown1,
      theBoldUnknown2,
      theBoldUnknown3,
      theBoldUnknown4,
      theBoldUnknown5,
      theBoldUnknown6,
      theBoldUnknown7,
      theBoldUnknown8,
      theBoldUnknown9,
      theBoldUnknown10,
      theBoldUnknown11
    ],
    'verse-for-this': [
      verseForThisDailyScripture,
      verseForThisGuidedExperience,
      verseForThisBibleContext,
      verseForThisPrayer,
      verseForThisShareableCards
    ]
  };

  const backendImages = {
    'songsage': [
      backend1,
      backend2
    ]
  };

  const renderProjectContent = (project) => {
    let content = project.content;
    
    // Add image replacement for sarcastic-box
    if (project.id === 'sarcastic-box') {
      content = content.replace(
        '/images/projects/sarcastic-box/breadboard-diagram.png',
        projectImages['sarcastic-box'].breadboard
      ).replace(
        '/images/projects/sarcastic-box/schematic.png',
        projectImages['sarcastic-box'].schematic
      ).replace(
        '/images/projects/sarcastic-box/prototype.png',
        projectImages['sarcastic-box'].prototype
      ).replace(
        '/images/projects/sarcastic-box/cardboard-box-portrait.png',
        projectImages['sarcastic-box'].portrait
      );
    }

    // Replace the image src in the content with the imported image
    if (project.id === 'v0idportal') {
      content = content.replace(
        '/images/projects/v0idportal/v0id-build.png',
        v0idBuildImage
      );
    }

    // Add flangebender image replacements
    if (project.id === 'flangebender-p') {
      content = content.replace(
        '/images/projects/flangebender-p/flanger-breadboard.png',
        projectImages['flangebender-p'].breadboard
      ).replace(
        '/images/projects/flangebender-p/flanger-schematic.png',
        projectImages['flangebender-p'].schematic
      ).replace(
        '/images/projects/flangebender-p/flanger-electronics.png',
        projectImages['flangebender-p'].electronics
      );
    }

    const contentElement = (
      <>
        {project.id === 'songsage' && (
          <>
            <div dangerouslySetInnerHTML={{ __html: content }} />
            <Carousel images={projectImages[project.id]} title="Screenshots" />
          </>
        )}
        {project.id === 'v0idportal' && (
          <>
            <div dangerouslySetInnerHTML={{ __html: content }} />
            <Carousel images={projectImages[project.id]} title="Scene Examples" />
            <CodeDisplay 
              title="V0ID-PORTAL.py"
              code={V0ID_PORTAL_CODE}
            />
          </>
        )}
        {project.id === 'sarcastic-box' && (
          <>
            <div dangerouslySetInnerHTML={{ __html: content }} />
            <h3 className="video-title">Enclosure</h3>
            <p className="sound-examples-description">I initially designed an enclosure using Rhino to perfectly integrate with my parts in a simple "box" enclosure.</p>
            <div className="stl-viewers-container">
              <StlModelViewer 
                url="/stl/sarcastic-box/charles-pet-peeve-box.stl"
                title="Box Base"
              />
              <StlModelViewer 
                url="/stl/sarcastic-box/charles-pet-peeve-top.stl"
                title="Box Top"
              />
            </div>
            <div className="image-container">
              <h4>Final Form</h4>
              <img src={projectImages['sarcastic-box'].portrait} alt="The final form of The Cardboard Constable" />
            </div>
            <p className="enclosure-description">
              Unfortunately my half-day-long 3D print failed due to printer error (the nozzle clogged in the middle of the print). With only a few hours left to go, I had to resort to my backup plan and use a cardboard box as the enclosure, effectively using the same design, but manually cut out. This is a case, however, where doing what is "worse" ultimately made the project better, in my opinion, as having the low fidelity design, and using a carboard box as the "head" of our sarcastic little friend, adds comedic irony in contrast with his pompous, know-it-all personality. The drawn on eyebrows add to this irony as well, and top off the character of an ever discerning character.
            </p>
            <CodeDisplay 
              title="SARCASTIC-BOX.ino"
              code={SARCASTIC_BOX_CODE}
            />
          </>
        )}
        {project.id === 'flangebender-p' && (
          <>
            {(() => {
              const demoPlaceholder = '<div id="flanger-demo-placeholder"></div>';
              const demoIndex = content.indexOf(demoPlaceholder);
              
              if (demoIndex !== -1) {
                const beforeDemo = content.substring(0, demoIndex);
                const afterDemo = content.substring(demoIndex + demoPlaceholder.length);
                
                return (
                  <>
                    <div dangerouslySetInnerHTML={{ __html: beforeDemo + '</div>' }} />
                    <FlangerDemo />
                    <div dangerouslySetInnerHTML={{ __html: '<div class="project-about">' + afterDemo }} />
                  </>
                );
              }
              
              return <div dangerouslySetInnerHTML={{ __html: content }} />;
            })()}
            <h3 className="video-title">Enclosure</h3>
            <p className="sound-examples-description">I designed an L-shaped enclosure using Rhino to house the Time-of-Flight sensors and electronics for the FlangeBender prototype.</p>
            <div className="stl-viewers-container">
              <StlModelViewer 
                url="/stl/flangebender-p/flanger-shell.stl"
                title="Flanger Shell"
              />
            </div>
            <p className="enclosure-description">
              The enclosure was designed to position the two Time-of-Flight sensors at a 90-degree angle to each other, allowing for independent hand gesture control of the flanger's amplitude and rate parameters. The L-shaped design provides clear spatial separation between the two control zones while maintaining a compact form factor suitable for desktop use during audio production.
            </p>
            <CodeDisplay 
              title="FLANGEBENDER.ino"
              code={FLANGEBENDER_CODE}
            />
          </>
        )}
        {project.id === 'stock-sentiment-tracker' && (
          <>
            {(() => {
              const webappCarouselIndex = content.indexOf('<div id="webapp-carousel"></div>');
              const cliCarouselIndex = content.indexOf('<div id="cli-carousel"></div>');
              
              const beforeWebapp = content.substring(0, webappCarouselIndex);
              const betweenCarousels = content.substring(
                webappCarouselIndex + '<div id="webapp-carousel"></div>'.length,
                cliCarouselIndex
              );
              const afterCli = content.substring(
                cliCarouselIndex + '<div id="cli-carousel"></div>'.length
              );
              
              return (
                <>
                  <div dangerouslySetInnerHTML={{ __html: beforeWebapp }} />
                  <Carousel images={projectImages[project.id].webapp} />
                  <div dangerouslySetInnerHTML={{ __html: betweenCarousels }} />
                  <Carousel images={projectImages[project.id].cli} />
                  <div dangerouslySetInnerHTML={{ __html: afterCli }} />
                </>
              );
            })()}
          </>
        )}        {project.id === 'remote-viewing-session-guide' && (
          <>
            <div dangerouslySetInnerHTML={{ __html: content }} />
          </>
        )}        {project.id === 'the-bold-unknown-content-generator' && (
          <>
            {(() => {
              const carouselPlaceholder = '<div id="screenshot-carousel"></div>';
              const carouselIndex = content.indexOf(carouselPlaceholder);
              
              if (carouselIndex !== -1) {
                const beforeCarousel = content.substring(0, carouselIndex);
                const afterCarousel = content.substring(carouselIndex + carouselPlaceholder.length);
                return (
                  <>
                    <div dangerouslySetInnerHTML={{ __html: beforeCarousel }} />
                    <Carousel images={projectImages[project.id]} title="Images" />
                    <div dangerouslySetInnerHTML={{ __html: afterCarousel }} />
                  </>
                );
              }
              
              return (
                <>
                  <div dangerouslySetInnerHTML={{ __html: content }} />
                  <Carousel images={projectImages[project.id]} title="Images" />
                </>
              );
            })()}
          </>
        )}
        {project.id === 'verse-for-this' && (
          <>
            {(() => {
              const galleryPlaceholder = '<div id="verse-for-this-gallery"></div>';
              const galleryIndex = content.indexOf(galleryPlaceholder);

              if (galleryIndex === -1) {
                return <div dangerouslySetInnerHTML={{ __html: content }} />;
              }

              const beforeGallery = content.substring(0, galleryIndex);
              const afterGallery = content.substring(galleryIndex + galleryPlaceholder.length);
              const galleryAlts = [
                'daily Scripture',
                'personalized Scripture search',
                'Bible context',
                'personalized prayer',
                'shareable verse card'
              ];

              return (
                <>
                  <div dangerouslySetInnerHTML={{ __html: beforeGallery }} />
                  <section className="verse-story" aria-labelledby="verse-story-title">
                    <div className="verse-story-heading">
                      <h3 id="verse-story-title">Product Walkthrough</h3>
                    </div>
                    <div className="verse-story-track">
                      {projectImages[project.id].map((image, index) => (
                        <div className="verse-story-panel" key={galleryAlts[index]}>
                          <img
                            src={image}
                            alt={`VerseForThis ${galleryAlts[index]} screen`}
                            loading="lazy"
                          />
                        </div>
                      ))}
                    </div>
                  </section>
                  <div dangerouslySetInnerHTML={{ __html: afterGallery }} />
                  <div className="app-store-link-section">
                    <a
                      className="app-store-button"
                      href="https://apps.apple.com/jp/app/verseforthis/id6770368066?l=en-US"
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="Download VerseForThis on the App Store"
                    >
                      <img src={appleLogo} alt="" className="app-store-logo no-popup" />
                      <span className="app-store-button-text">
                        <span className="app-store-button-eyebrow">Download on the</span>
                        <span className="app-store-button-name">App Store</span>
                      </span>
                    </a>
                  </div>
                </>
              );
            })()}
          </>
        )}



        {backendImages[project.id] && (
          <>
            <h3 className="backend-title">Backend Flow Diagrams</h3>
            <Carousel images={backendImages[project.id]} /* zoomable={true} */ className="backend-carousel" />
          </>
        )}
        
        {project.id === 'songsage' && (
          <div className="github-unavailable-section">
            <p className="github-unavailable-text">A GitHub link is not currently available as I do not intend to open source this project at this time.</p>
          </div>
        )}
      </>
    );
    return contentElement;
  };

  return (
    <>
      <div className="project-feed-header">
        <h2>Project Feed</h2>
      </div>
      <div className="projects-stack">
        {projects.map(project => (
          <div 
            key={project.id}
            ref={el => projectRefs.current[project.id] = el}
            className={`project-item ${expandedId === project.id ? 'expanded' : ''}`}
          >
            <div 
              className="project-thumbnail"
              onClick={() => toggleProject(project.id)}
            >
              <img src={thumbnails[project.id]} alt={project.title} />
              <div className="thumbnail-overlay">
                <h3>{project.title}</h3>
                <p>{project.description}</p>
                <span className="expand-hint">Click to expand</span>
              </div>
              <div className="expand-indicator">
                <svg viewBox="0 0 24 24">
                  <polyline points="6 9 12 15 18 9"></polyline>
                </svg>
              </div>
            </div>
            
            <div className="project-content">
              <ImagePopupWrapper className="content-wrapper">
                {renderProjectContent(project)}
              </ImagePopupWrapper>
            </div>
          </div>
        ))}
      </div>
    </>
  );
};

export default Projects; 